import { Size } from '../../types';

export interface SizeOrientation {
  label: string;
  value: string;
  price: number;
  aspectRatio: number;
}

export interface ExtendedSize extends Size {
  portrait: SizeOrientation;
  landscape: SizeOrientation | null;
}

export interface DpiWarning {
  level: 'error' | 'warning' | 'info' | 'success';
  message: string;
}

export interface ImageDimensions {
  width: number;
  height: number;
}

export const MATERIALS = ['Canvas'] as const;

export const FINISHES = [
  { label: 'Glossy', value: 'glossy', frameSurcharge: 0, hangerSurcharge: 0 }
] as const;
